import styled from 'styled-components/macro'

export const OptionsList = styled.ul`
  position: absolute;
  list-style: none;
  padding: 0;
  margin-top: 0;
  height: max-content;
  max-height: 100px;
  overflow: scroll;
  background: rgb(255, 255, 255);
  width: 100%;
  z-index: 1;
  border: 1px solid rgb(156, 156, 156);
  border-top: none;
  box-sizing: border-box;

  &.personal-details-edit {
    top: 100%;
    overflow: auto;
  }
`

export const OptionItem = styled.li`
  height: 25px;
  margin: 5px;
  cursor: pointer;

  &:hover {
    background: #f3f3f3;
  }
`

export const NoOption = styled.div`
  position: absolute;
  top: 100%;
  overflow: auto;
  list-style: none;
  padding: 5px;
  margin-top: 0;
  height: max-content;
  max-height: 100px;
  background: rgb(255, 255, 255);
  width: 100%;
  z-index: 1;
  border: 1px solid rgb(156, 156, 156);
  border-top: none;
  box-sizing: border-box;
`
